import * as destinationPackageService from "../../../services/destinationPackage";
import * as settings from "../../../services/settings";
import * as warehouseService from "../../../services/warehouse";

import { ArrowLeftOutlined, DeleteOutlined, EditOutlined, PlusCircleOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Typography,
  notification,
} from "antd";
import { getRouteLabel, isEmpty } from "../../../utils/common";
import { useCallback, useEffect, useRef, useState } from "react";

import { ModalDelete } from "../../../Components/model/modal/delete";
import dayjs from "dayjs";
import permissions from "../../../../configs/permission";
import { useAccessToken } from "../../../contexts/AccessTokenContext";
import { useNavigate } from "react-router-dom";
import { usePermission } from "../../../hooks/usePermission";
import { useTranslation } from "react-i18next";

const { RangePicker } = DatePicker;
const initPage = { limit: 10, page: 1 };
let promise;
export const DestinationPackagePage = () => {
  const { hasPermission, isSuperuser } = usePermission();
  const [fromSearch] = Form.useForm();
  const { accessToken } = useAccessToken();
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation("destinationpackage", "buttons", "common");
  const { t: tOps } = useTranslation("options", { keyPrefix: "Package" });
  const [search, setSearch] = useState(initPage);
  const [destinationPackageData, setDestinationPackageData] = useState([]);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [prepareDeleteData, setPrepareDeleteData] = useState({});
  const [dateRange, setDateRange] = useState([]);
  const [destination, setDestination] = useState([]);
  const [origin, setOrigin] = useState([]);
  const [countSelect, setCountSelect] = useState(0);
  const [isOpenButton, setIsOpenButton] = useState(true);
  const [defaultPackageStatus, setDefaultPackageStatus] = useState("all");

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRowsValues, setSelectedRowsValues] = useState([]);
  const [tempSearch, setTempSearch] = useState();

  const exportExcel = async () => {
    setLoading(true);
    const params = { page: 1, limit: total };
    try {
      const request = {
        ids: selectedRowKeys.length ? JSON.stringify(selectedRowKeys) : [],
        ...params,
      };

      const response = await destinationPackageService.exportExcel(accessToken, request);
      // Extract filename from headers
      const contentDisposition = response.headers["content-disposition"];
      let filename = `destination_warehouse-${dayjs().format("YYYY-MM-DD")}`; // Fallback filename
      if (contentDisposition) {
        const matches = contentDisposition.match(/filename="([^"]+)"/);
        if (matches && matches[1]) {
          filename = matches[1];
        }
      }

      // Create a blob from the response
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      // Create a link for downloading
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename; // Set the filename
      document.body.appendChild(link);
      link.click(); // Trigger download
      document.body.removeChild(link); // Cleanup

      openNotificationWithIcon(settings.NotificationType.SUCCESS, <>{"Success."}</>, <>{"Export Excel Success"}</>);
    } catch (err) {
      console.error("[DestinationPackagePage] exportExcel: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
    }
    setLoading(false);
  };

  const onSelectAll = async () => {
    setCountSelect(total);
    setIsOpenButton(false);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, value) => {
      setSelectedRowKeys(selectedRowKeys);
      setSelectedRowsValues(value);
      setCountSelect(value.length);
      setIsOpenButton(false);
    },
  };

  const navigate = useNavigate();
  const { Title, Link } = Typography;
  const { Search } = Input;
  const [total, setTotal] = useState(0);

  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = useCallback(
    (type, message, description) => {
      api[type]({ message, description });
    },
    [api]
  );

  const onDeleteDestinationPackage = async (data) => {
    try {
      if (Array.isArray(data) && data.length > 0) {
        const prepareDeleteOriginPackage = { ids: data };
        await destinationPackageService.deleteMultiDestinationPackage(accessToken, prepareDeleteOriginPackage);
        setSelectedRowKeys([]);
        setSelectedRowsValues([]);
      } else {
        const prepareDeleteOriginPackage = { id: data.id };
        await destinationPackageService.deleteDestinationPackage(accessToken, prepareDeleteOriginPackage);
      }
      openNotificationWithIcon(
        settings.NotificationType.SUCCESS,
        <>{"Success."}</>,
        <>{"Delete origin package success."}</>
      );
      setPrepareDeleteData({});
      setIsOpenDelete(false);
      findDestinationPackage(initPage);
      setLoading(false);
    } catch (err) {
      console.error("[DestinationPackagePage] onDeleteDestinationPackage: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      setLoading(false);
    }
  };

  const findDestinationPackage = useCallback(
    async (param) => {
      try {
        if (param.package_status == "all" || param.package_status == undefined) {
          param.package_status = defaultPackageStatus === "all" ? undefined : defaultPackageStatus;
        }

        const data = await destinationPackageService.getDestinationPackage(accessToken, param);
        setTotal(data?.totalCount);
        setDestinationPackageData(data?.queryDestinationPackage);
        setSearch({ ...param });
        setLoading(false);
      } catch (err) {
        console.error("[DestinationPackagePage] findDestinationPackage: ", err);
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
        setLoading(false);
      }
    },
    [accessToken]
  );

  const onSearch = async (value) => {
    setLoading(true);
    try {
      const { search, search_date, search_destination, search_origin, search_package_status, search_route, ...data } =
        value;
      let start_date;
      let end_date;
      if (data && search_date) {
        start_date = dateRange[0] || undefined;
        end_date = dateRange[1] || undefined;
      }

      const searchText = search != undefined ? search.trim() : "";
      const values = {
        start_date: start_date,
        end_date: end_date,
        reference: searchText,
        container: searchText,
        package_status: normalizeSelection(search_package_status),
        route: normalizeSelection(search_route),
        origin: normalizeSelection(search_origin),
        destination: normalizeSelection(search_destination),
      };

      setTempSearch(value);

      await findDestinationPackage({
        ...values,
        page: value.page ?? initPage.page,
        limit: value.limit ?? initPage.limit,
      });
    } finally {
      setLoading(false);
    }
  };

  const normalizeSelection = (values) => {
    const modify = values !== "all" ? values : undefined;
    return modify;
  };

  const mappingPackageStatus = (value) => {
    switch (value) {
      case "0":
        return tOps("Package_Status.At_The_Origin_Warehouse");
      case "1":
        return tOps("Package_Status.Transporting_To_The_Destination_Warehouse");
      case "2":
        return tOps("Package_Status.At_The_Destination_Warehouse");
      case "3":
        return tOps("Package_Status.Delivered");
    }
  };

  const fetchWareHouse = useCallback(
    async (param) => {
      let resDestination = [{ label: tOps("All"), value: "all" }];
      let resOrigin = [{ label: tOps("All"), value: "all" }];
      const data = await warehouseService.getWarehouses(accessToken, param);
      if (data !== undefined) {
        data.warehouse.map((value) => {
          if (value.is_destination === true) {
            resDestination.push({
              value: value.id,
              label: value.warehouse_code,
            });
          }
          if (value.is_origin === true) {
            resOrigin.push({
              value: value.id,
              label: value.warehouse_code,
            });
          }
        });
      }
      setDestination(resDestination);
      setOrigin(resOrigin);
    },
    [accessToken, tOps]
  );

  const hasInitialized = useRef(false);
  useEffect(() => {
    if (!accessToken || hasInitialized.current) return;
    hasInitialized.current = true;
    (async () => {
      await Promise.all([fetchWareHouse(initPage), onSearch({ search_package_status: "all", ...initPage })]);
    })();
  }, [accessToken, fetchWareHouse]);

  const handleDateChange = useCallback((dates, dateStrings) => {
    setDateRange(dateStrings);
  }, []);

  const disableFutureDates = useCallback((current) => {
    return current && current.isAfter(dayjs().endOf("day"));
  }, []);

  const reset = async () => {
    fromSearch.resetFields();
    setDefaultPackageStatus("all");
    try {
      setCountSelect(0);
      setLoading(true);
      await findDestinationPackage(initPage);
    } finally {
      setLoading(false);
    }
  };

  const onFinish = async () => {
    const values = fromSearch.getFieldsValue();
    try {
      setLoading(true);
      await onSearch({ ...values, initPage });
    } finally {
      setLoading(false);
    }
  };
  const packageStatus = [
    { value: "all", label: tOps("All") },
    { value: "0", label: tOps("Package_Status.At_The_Origin_Warehouse") },
    { value: "1", label: tOps("Package_Status.Transporting_To_The_Destination_Warehouse") },
    { value: "2", label: tOps("Package_Status.At_The_Destination_Warehouse") },
    { value: "3", label: tOps("Package_Status.Delivered") },
  ];

  const route = [
    { value: "all", label: tOps("All") },
    { value: "land", label: tOps("Route.Land") },
    { value: "sea", label: tOps("Route.Sea") },
  ];

  const columns = [
    {
      title: t("Destination_Package_Table.Table_ID"),
      dataIndex: "id",
      render: (_, record) => (
        <Link
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/package/destinationpackage/create", {
              state: { type: "EDIT", destinationPackageData: record },
            });
          }}
        >
          {record.id}
        </Link>
      ),
    },
    {
      title: t("Destination_Package_Table.Table_Reference"),
      dataIndex: "reference",
      render: (_, record) => (
        <p
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/package/destinationpackage/create", {
              state: { type: "EDIT", destinationPackageData: record },
            });
          }}
        >
          {record.reference}
        </p>
      ),
    },
    {
      title: t("Destination_Package_Table.Table_Bill_Status"),
      dataIndex: "bill_status",
      render: (_, record) => {
        const app_destinationpackageservice = record.app_destinationpackageservice;

        // Check if there are services
        if (app_destinationpackageservice && app_destinationpackageservice.length > 0) {
          // Loop through services and get bill_status
          const billStatuses = app_destinationpackageservice.map((element) => {
            const customerBillItems = element.app_customerbillitem;
            const customerBillItem = customerBillItems.length > 0 ? customerBillItems[0] : null;
            const customerBill = customerBillItem ? customerBillItem.app_customerbill : null;
            return customerBill ? customerBill.bill_status : "-";
          });

          // If there are multiple statuses, you can join them or choose the first one
          return <p>{billStatuses.join(", ")}</p>; // Join if there are multiple statuses
        } else {
          return <p>{"-"}</p>; // Default if no services
        }
      },
    },
    {
      title: t("Destination_Package_Table.Table_Container"),
      dataIndex: "container",
      render: (_, record) =>
        record.app_originpackage.app_originpackagetransportation.length > 0
          ? record.app_originpackage.app_originpackagetransportation[0].app_origintransportation.container
          : "-",
    },
    {
      title: t("Destination_Package_Table.Table_Combined_Box"),
      dataIndex: "box",
      render: (_, record) => record.box || "-",
    },
    {
      title: t("Destination_Package_Table.Table_Tracking"),
      dataIndex: "tracking",
      render: (_, record) => record.tracking || "-",
    },
    {
      title: t("Destination_Package_Table.Table_Route"),
      dataIndex: "route",
      render: (_, record) => {
        const label = getRouteLabel(record?.route, i18n);
        return <p>{label}</p>;
      },
    },
    {
      title: t("Destination_Package_Table.Table_Origin"),
      dataIndex: "origin",
      render: (_, record) => {
        const app_originpackage = record.app_originpackage;
        const app_warehouse =
          app_originpackage.app_warehouse_app_originpackage_origin_idToapp_warehouse?.warehouse_code || "-";
        return <p>{app_warehouse}</p>;
      },
    },
    {
      title: t("Destination_Package_Table.Table_Destination"),
      dataIndex: "destination",
      render: (_, record) => record.app_warehouse?.warehouse_code || "-",
    },
    {
      title: t("Destination_Package_Table.Table_Total_Received"),
      dataIndex: "total_received",
    },
    {
      title: t("Destination_Package_Table.Table_Total_Sent"),
      dataIndex: "total_sent",
    },
    {
      title: t("Destination_Package_Table.Table_Origin_Package_Service"),
      dataIndex: "app_originpackageservice",
      render: (_, record) => {
        const app_originpackage = record.app_originpackage;

        if (app_originpackage && app_originpackage.app_originpackageservice?.length > 0) {
          const packageServices = app_originpackage.app_originpackageservice.map((element) => element.package_service);
          return <p>{packageServices.join(", ")}</p>; // Join package services with a comma
        } else {
          return <p>{"-"}</p>; // Default if no services
        }
      },
    },
    {
      title: t("Destination_Package_Table.Table_Destination_Package_Service"),
      dataIndex: "app_destinationpackageservice",
      render: (_, record) => {
        const app_destinationpackageservice = record.app_destinationpackageservice;
        if (app_destinationpackageservice && app_destinationpackageservice?.length > 0) {
          const packageServices = app_destinationpackageservice.map((element) => element.package_service);
          return <p>{packageServices.join(", ")}</p>;
        } else {
          return <p>{"-"}</p>;
        }
      },
    },
    {
      title: t("Destination_Package_Table.Table_Delivery_Type"),
      dataIndex: "delivery_type",
      render: (_, record) => (record.delivery_type ? record.delivery_type : "-"),
    },
    {
      title: t("Destination_Package_Table.Table_Package_Status"),
      dataIndex: "package_status",
      render: (_, record) => {
        const package_status = record.package_status || "";
        return <p>{mappingPackageStatus(package_status)}</p>;
      },
    },
    {
      title: t("Destination_Package_Table.Table_Note"),
      dataIndex: "note",
      render: (_, record) => record.note || "-",
    },
    {
      title: t("Destination_Package_Table.Table_Destination_Delivery"),
      dataIndex: "destination_delivery",
      render: (_, record) => {
        const destinationpackagedelivery = record.app_destinationpackagedelivery;
        if (destinationpackagedelivery && destinationpackagedelivery.length > 0) {
          const vehicle = destinationpackagedelivery.map(
            (element) => element.id + ` : ` + element.app_destinationdelivery?.vehicle
          );
          return <p>{vehicle.join(", ")}</p>;
        } else {
          return <p>{"-"}</p>;
        }
      },
    },
    {
      title: t("Destination_Package_Table.Table_Customer"),
      dataIndex: "app_customer",
      render: (_, record) =>
        record.app_customer
          ? record.app_company?.company_code +
            "-" +
            record.app_customer.app_sale?.sale_code +
            record.app_customer.customer_code
          : "-",
    },
    {
      title: t("Destination_Package_Table.Table_Description"),
      dataIndex: "package_description",
      render: (_, record) => record.package_description || "",
    },
    {
      title: t("Destination_Package_Table.Table_Type"),
      dataIndex: "type",
      render: (_, record) => record.package_type || "",
    },
    {
      title: t("Destination_Package_Table.Table_Total_Count"),
      dataIndex: "total_count",
    },
    {
      title: t("Destination_Package_Table.Table_Length"),
      dataIndex: "length",
    },
    {
      title: t("Destination_Package_Table.Table_width"),
      dataIndex: "width",
    },
    {
      title: t("Destination_Package_Table.Table_Height"),
      dataIndex: "height",
    },
    {
      title: t("Destination_Package_Table.Table_Volume"),
      dataIndex: "volume",
    },
    {
      title: t("Destination_Package_Table.Table_Total_Volume"),
      dataIndex: "total_volume",
    },
    {
      title: t("Destination_Package_Table.Table_Weight"),
      dataIndex: "weight",
    },
    {
      title: t("Destination_Package_Table.Table_Total_Weight"),
      dataIndex: "total_weight",
    },
    {
      title: t("Destination_Package_Table.Table_Weight_Type"),
      dataIndex: "weight_type",
    },
    {
      title: t("Destination_Package_Table.Table_Amount"),
      dataIndex: "amount",
    },
    {
      title: t("Destination_Package_Table.Table_Total_Amount"),
      dataIndex: "total_amount",
    },
    {
      title: t("Destination_Package_Table.Table_Density"),
      dataIndex: "density",
    },
    {
      title: t("Create_At", { ns: "common" }),
      dataIndex: "created_at",
      render: (_, record) =>
        record.created_at != null ? dayjs(record.created_at).format("YYYY-MM-DD hh:mm:ss A") : "-",
    },
    {
      title: t("Update_At", { ns: "common" }),
      dataIndex: "updated_at",
      render: (_, record) =>
        record.updated_at != null ? dayjs(record.updated_at).format("YYYY-MM-DD hh:mm:ss A") : "-",
    },
    {
      title: t("Edit", { ns: "common" }),
      dataIndex: "edit",
      key: "edit",
      render: (_, row) => (
        <Button
          type="link"
          onClick={() => {
            navigate("/package/destinationpackage/create", {
              state: { type: "EDIT", destinationPackageData: row },
            });
          }}
        >
          <EditOutlined />
        </Button>
      ),
    },
    {
      title: t("Delete", { ns: "common" }),
      dataIndex: "delete",
      key: "delete",
      render: (_, record) => (
        <Button
          type="link"
          disabled={!hasPermission(permissions.DestinationPackage.DELETE)}
          onClick={() => {
            setIsOpenDelete(true);
            setPrepareDeleteData(record);
            // onDeleteDestinationPackage(record);
          }}
        >
          <DeleteOutlined />
        </Button>
      ),
    },
  ];

  const items = [
    { title: t("Page_Body_Tab_Menu.Home", { ns: "menus" }) },
    { title: t("Page_Body_Tab_Menu.Menu", { ns: "menus" }) },
    { title: t("Menu_Package.Title_Package", { ns: "menus" }) },
    {
      title: (
        <a href="/package/destinationpackage" style={{ fontWeight: 600, color: "black" }}>
          {t("Menu_Package.Destination_Package", { ns: "menus" })}
        </a>
      ),
    },
  ];

  return (
    <>
      {contextHolder}
      <Spin spinning={loading}>
        <Row flex={1}>
          <Col span={24}>
            <Breadcrumb items={items} />
            <Row style={{ padding: "15px 0px" }}>
              <Col span={24}>
                <Title
                  level={4}
                  style={{
                    textWrap: "nowrap",
                    display: "flex",
                    gap: "7px",
                  }}
                >
                  <ArrowLeftOutlined style={{ fontSize: "20px" }} />
                  {t("Menu_Package.Destination_Package", { ns: "menus" })}
                </Title>
              </Col>
            </Row>
            <Row style={{ display: "flex", justifyContent: "left", overflowX: "auto" }}>
              <Col span={12}>
                <Form
                  form={fromSearch}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  labelAlign="left"
                  layout="horizontal"
                  onFinish={onFinish}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      fromSearch.submit();
                    }
                  }}
                  initialValues={{
                    search_date: [dayjs().startOf("day"), dayjs().endOf("day")], // Set initial value for the date range
                    search: undefined, // Initial value for search
                    search_package_status: "all", // Initial value for package status
                    search_origin: "all", // Initial value for origin
                    search_destination: "all", // Initial value for destination
                    search_route: "all", // Initial value for route
                  }}
                >
                  <Row flex={1}>
                    <Col span={24} style={{ minWidth: 280 }}>
                      <Form.Item name="search_date" label={t("Create_At", { ns: "common" })}>
                        <RangePicker
                          allowEmpty
                          style={{ width: "100%", minWidth: 200 }}
                          onChange={handleDateChange}
                          disabledDate={disableFutureDates}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24} style={{ minWidth: 280 }}>
                      <Form.Item name="search" label={t("Search", { ns: "common" })}>
                        <Input size="default" placeholder="Reference / Tracking" style={{ minWidth: 200 }} />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24} style={{ minWidth: 280 }}>
                      <Form.Item label={t("Search.Input_Package_Status")} name="search_package_status">
                        <Select
                          placeholder={"Please Select Package Status"}
                          options={packageStatus}
                          style={{ minWidth: 200 }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24} style={{ minWidth: 280 }}>
                      <Form.Item label={t("Search.Input_Origin")} name="search_origin">
                        <Select placeholder={"Please Select Origin"} options={origin} style={{ minWidth: 200 }} />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24} style={{ minWidth: 280 }}>
                      <Form.Item label={t("Search.Input_Destination")} name="search_destination">
                        <Select
                          placeholder={"Please Select Destination"}
                          options={destination}
                          style={{ minWidth: 200 }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24} style={{ minWidth: 280 }}>
                      <Form.Item label={t("Search.Input_Route")} name="search_route">
                        <Select placeholder={"Please Select Route"} options={route} style={{ minWidth: 200 }} />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="end" align="middle">
                    <Col span={24} style={{ textAlign: "end" }}>
                      <Form.Item>
                        <Button type="primary" htmlType="submit">
                          {t("BTN_Search", { ns: "buttons" })}
                        </Button>
                        <Button type="default" onClick={() => reset()} style={{ marginLeft: "5px" }}>
                          {t("BTN_Reset", { ns: "buttons" })}
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <div className="flex justify-between mb-4">
              {hasPermission(permissions.DestinationPackage.DELETE) ? (
                <Button
                  type="primary"
                  disabled={isEmpty(selectedRowKeys)}
                  onClick={() => {
                    setIsOpenDelete(true);
                    setPrepareDeleteData(selectedRowKeys);
                  }}
                >
                  {t("Button_Destination_Packages.BTN_Delte_All")}
                </Button>
              ) : (
                <div />
              )}
              <Space direction="inline">
                {hasPermission(permissions.DestinationPackage.EXPORT) && (
                  <Button type="primary" disabled={isOpenButton} onClick={exportExcel}>
                    {t("BTN_Export_Excel", { ns: "buttons" })}
                  </Button>
                )}
                {hasPermission(permissions.DestinationPackage.ADD) && (
                  <Button
                    type="primary"
                    icon={<PlusCircleOutlined />}
                    onClick={() => {
                      navigate("/package/destinationpackage/create", {
                        state: { type: "CREATE" },
                      });
                    }}
                  >
                    {t("Button_Destination_Packages.BTN_Add")}
                  </Button>
                )}
              </Space>
            </div>
          </Col>
        </Row>
        <Row align="middle" justify="center">
          <Col span={24}>
            <Card>
              <Row align="middle" justify="center">
                <Col span={24}>
                  {`${t("Select", { ns: "common" })}: ${countSelect} to ${total}`}&nbsp;
                  <Link onClick={onSelectAll} target="_blank">
                    {t("Select_All", { ns: "common" })}
                  </Link>
                </Col>
              </Row>
              <Table
                loading={loading}
                rowSelection={{ type: "checkbox", ...rowSelection }}
                columns={columns}
                dataSource={destinationPackageData}
                scroll={{ x: "max-content" }}
                rowKey={(record) => record.id}
                pagination={{
                  defaultPageSize: search.limit,
                  pageSizeOptions: ["10", "20", "50", "100"],
                  current: search.page,
                  pageSize: search.limit,
                  total: total,
                  onChange: (page, limit) => {
                    onSearch({ ...tempSearch, page, limit });
                  },
                  showSizeChanger: true,
                }}
                style={{ cursor: "pointer" }}
              />
            </Card>
          </Col>
        </Row>
        <ModalDelete
          isOpen={isOpenDelete}
          handleCloseModal={() => {
            setIsOpenDelete(false);
          }}
          onClick={() => {
            onDeleteDestinationPackage(prepareDeleteData);
          }}
          dataDetail={prepareDeleteData}
          t={t}
        />
      </Spin>
    </>
  );
};
